"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blue = {
  c10: '#002451',
  c20: '#003A79',
  c30: '#0051A2',
  c40: '#0069D0',
  c50: '#007AF0',
  c60: '#498FFF',
  c70: '#84AAFF',
  c80: '#C5D4FF',
  c90: '#ECF0FF',
  c100: '#FFFFFF'
};